/**
 * Check if a given object implements the SelfLearningUnitContentQueryLessonByContentId interface.
 */
export function instanceOfSelfLearningUnitContentQueryLessonByContentId(value) {
    let isInstance = true;
    isInstance = isInstance && "contentId" in value;
    return isInstance;
}
export function SelfLearningUnitContentQueryLessonByContentIdFromJSON(json) {
    return SelfLearningUnitContentQueryLessonByContentIdFromJSONTyped(json, false);
}
export function SelfLearningUnitContentQueryLessonByContentIdFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'contentId': json['contentId'],
    };
}
export function SelfLearningUnitContentQueryLessonByContentIdToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'contentId': value.contentId,
    };
}
